import { DriverRegistrationPortalNoAuthService } from '@gen/driverRegistration/driverRegistrationPortalNoAuth';
import { IAppState } from '../types';

export const getExperimentParameters =
  (eventKey: string) =>
  (
    state: IAppState
  ): DriverRegistrationPortalNoAuthService.ExperimentParameters =>
    state.experiments[eventKey];
